import Calendly from '@atoms/Calendly';
import { Box } from '@chakra-ui/react';
import DefaultLayout from '@components/layout/layout/DefaultLayout';
import { useRouter } from 'next/router';

// Get utm params from Next JS query.
const getUtmParamsFromQuery = (query) =>
  Object.keys(query).reduce((acc, curr) => {
    if (curr.includes('utm')) {
      acc[curr] = query[curr];
    }
    return acc;
  }, {});

function CallUs() {
  const router = useRouter();
  const utmParams = { utmContent: 'navBar', ...getUtmParamsFromQuery(router.query) };
  const agentSlug = router.query?.agent;
  const eventSlug = agentSlug ? `${agentSlug}/welcome-to-medicare` : 'fair-square-medicare/talk-to-an-expert';

  return (
    <DefaultLayout>
      <Box bg="darkBackground" minH="100vh" py={8}>
        <Calendly utmParams={utmParams} eventSlug={eventSlug} />
      </Box>
    </DefaultLayout>
  );
}

export default CallUs;
